import { Box, useDisclosure, useToast } from "@chakra-ui/react";
import { DEFAULT_TOAST_DURATION } from "@kg-pos/common";
import {
  StoreLineNotificationDataFragment,
  useGetStoreLineNotificationsByStoreIdQuery,
  useUpdateStoreLineNotificationMutation,
} from "__generated__/graphql";
import { MainCardContainer } from "components/containers/main-card";
import { ErrorLayout } from "components/layouts/error";
import { LoadingLayout } from "components/layouts/loading";
import { MainTable } from "components/molecules/main-table";
import { ConfirmModal } from "components/organisms/confirm-modal";
import { PageTitle } from "components/organisms/page-title";
import { useTitle } from "hooks/useTitle";
import React, { useState } from "react";
import { routeConstants } from "routes";

const columns = [
  {
    Header: "店舗",
    accessor: "store.name",
  },
  {
    Header: "LINE名",
    accessor: "displayName",
  },
  {
    Header: "有効化",
    accessor: "isEnabled",
    Cell: (props: any) => <div>{props.value ? "✅" : ""}</div>,
  },
];

export const LineNotificationPage: React.VFC = () => {
  useTitle("LINE連携");
  const { loading, error, data, refetch } = useGetStoreLineNotificationsByStoreIdQuery({
    fetchPolicy: "cache-and-network",
  });
  const [updateStoreLineNotification] = useUpdateStoreLineNotificationMutation();
  const updateModal = useDisclosure();
  const [record, setRecord] = useState<StoreLineNotificationDataFragment | null>(null);
  const toast = useToast();

  if (loading) return <LoadingLayout />;
  if (error) return <ErrorLayout />;

  const handleClick = (row: StoreLineNotificationDataFragment): void => {
    setRecord(row);
    updateModal.onOpen();
  };

  return (
    <>
      <PageTitle
        title="LINE連携"
        breadCrumbItems={[
          { label: "LINE連携", path: routeConstants.lineNotification, active: true },
        ]}
      />
      <MainCardContainer>
        <Box pt="4">
          <MainTable
            data={data?.getStoreLineNotificationsByStoreId ?? []}
            columns={columns}
            handleClick={handleClick}
          />
          {updateModal.isOpen && record && (
            <ConfirmModal
              title="有効化切り替え"
              mainText={`店舗${record.store?.name}と${record.displayName}のLINE連携を${
                record.isEnabled ? "無効化" : "有効化"
              }しますか？`}
              isOpen={updateModal.isOpen}
              onClose={updateModal.onClose}
              submit={async () => {
                await updateStoreLineNotification({ variables: { id: record.id } });
                await refetch();
                setRecord(null);
                toast({
                  title: `LINE連携を${record.isEnabled ? "無効化" : "有効化"}しました。`,
                  status: "success",
                  duration: DEFAULT_TOAST_DURATION,
                  isClosable: true,
                });
              }}
            />
          )}
        </Box>
      </MainCardContainer>
    </>
  );
};
